import { NgModule } from '@angular/core';
import { StickyBarModule } from '@app/content/shared/sticky-bar/sticky-bar.module';
import { OptInNotificationModule } from '@app/my-zone/shared/opt-in-notification/opt-in-notification.module';
import { ReportClaimButtonModule } from '@app/my-zone/shared/report-claim-button/report-claim-button.module';
import { ChatbotEntryModule } from '@app/shared/customer-service/chatbot/chatbot-entry/chatbot-entry.module';
import { InsuranceImagesModule } from '@app/shared/insurance/insurance-images/insurance-images.module';
import { NewsCarouselModule } from '@app/shared/news-carousel/news-carousel.module';
import { SharedModule } from '@app/shared/shared.module';
import { MyZoneStoreModule } from '@app/store/my-zone/my-zone-store.module';
import { MyZoneRoutingModule } from './my-zone-routing.module';
import { MyZoneComponent } from './my-zone.component';
import { MyZoneContainer } from './my-zone.container';
import { InsuranceControlModule } from './shared/insurance-control/insurance-control.module';
import { NotificationBannerModule } from './shared/notification-banner/notification-banner.module';
import { SidemenuModule } from './shared/sidemenu/sidemenu.module';

@NgModule({
    imports: [
        MyZoneRoutingModule,
        ReportClaimButtonModule,
        SharedModule,
        StickyBarModule,
        NewsCarouselModule,
        NotificationBannerModule,
        SidemenuModule,
        MyZoneStoreModule,
        ChatbotEntryModule,
        InsuranceImagesModule,

        // follow up pages
        InsuranceControlModule,
        OptInNotificationModule,
    ],
    declarations: [MyZoneContainer, MyZoneComponent],
})
export class MyZoneModule {}
